import { Component, ChangeDetectionStrategy, input } from '@angular/core'

import { State, Color } from './morph-button.enums'

@Component({
  selector: 'bo-morph-button',
  templateUrl: './morph-button.html',
  styleUrls: ['./morph-button.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class MorphButton {
  readonly state = input<State>(undefined)
  readonly color = input<Color>(undefined)
}
